var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 1.21436H2.14293C1.76405 1.21436 1.40068 1.36487 1.13277 1.63277C0.864865 1.90068 0.714355 2.26405 0.714355 2.64293V18.3572C0.714355 18.7361 0.864865 19.0995 1.13277 19.3674C1.40068 19.6353 1.76405 19.7858 2.14293 19.7858H15.0001C15.379 19.7858 15.7423 19.6353 16.0102 19.3674C16.2781 19.0995 16.4286 18.7361 16.4286 18.3572V11.9286M0.714355 15.5001H16.4286M5.00007 4.78578H7.85721M5.00007 8.35721H6.42864",
    stroke: "#FD8238",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8487 11.2231L8.56299 11.9946L9.27727 7.6517L15.3201 1.63741C15.4529 1.50351 15.6109 1.39724 15.785 1.32471C15.9591 1.25218 16.1458 1.21484 16.3344 1.21484C16.523 1.21484 16.7097 1.25218 16.8838 1.32471C17.0579 1.39724 17.2159 1.50351 17.3487 1.63741L18.863 3.1517C18.9969 3.2845 19.1032 3.4425 19.1757 3.61659C19.2482 3.79067 19.2856 3.9774 19.2856 4.16598C19.2856 4.35457 19.2482 4.54129 19.1757 4.71538C19.1032 4.88946 18.9969 5.04747 18.863 5.18027L12.8487 11.2231Z",
    stroke: "#FD8238",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview1);
export default __webpack_public_path__ + "static/media/review 1.ec792074c3889a791243709caa9420a5.svg";
export { ForwardRef as ReactComponent };